import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            setError(errMsg(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            title="Recupera tu acceso"
            subtitle="Te enviamos un enlace para crear una contraseña nueva."
            footer={<>¿Ya te acuerdas? <Link to="/entrar" className="font-semibold text-nm-accent">Vuelve a entrar</Link></>}
        >
            {done ? (
                <div className="rounded-2xl border border-nm-line bg-nm-surface p-6" data-testid="forgot-done">
                    <p className="font-semibold text-nm-ink">Revisa tu correo</p>
                    <p className="mt-2 text-sm text-nm-muted">
                        Si existe una cuenta con <span className="font-medium text-nm-ink">{email}</span>, te hemos
                        enviado un enlace para restablecer tu contraseña. Caduca en una hora.
                    </p>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
                    <div className="space-y-1.5">
                        <Label htmlFor="email">Correo</Label>
                        <Input id="email" type="email" data-testid="forgot-email" value={email}
                            onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" required />
                    </div>
                    {error && <p className="rounded-lg bg-nm-accent-soft px-3 py-2 text-sm text-nm-accent">{error}</p>}
                    <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
                        {loading ? "Enviando..." : "Enviarme el enlace"}
                    </Button>
                </form>
            )}
        </AuthShell>
    );
}
